import React, { Fragment } from "react";
import { CCCHistoryCard } from "../../components/About/CCCHistoryCard";
import { PageHero } from "../../components/Global/PageHero";
import { BackToTop } from "../../templates/BackToTop";

export const CCChistory = () => (
  <Fragment>
    <PageHero
      eyebrow="Our Heritage"
      title="CCC"
      highlight="History"
      subtitle="Dive right in and learn about this great church."
    />
    <CCCHistoryCard />
    <BackToTop />
  </Fragment>
);
